module.exports = require("./ar-MA.js");